import { getDesktopKey } from "./admin-app-constants";

export const generateStyleVariables = (
  styles: Record<string, string | number | null | undefined> = {}
): Record<string, string | number> => {
  const cssVars: Record<string, string | number> = {};

  Object.entries(styles || {}).forEach(([property, value]) => {
    const standardizedValue = standardizeStyle(property, value) as
      | string
      | number;

    // "auto" is a literal sentinel: each block resolves what it means itself
    // (LayoutBlock → SCSS container-width fallback, Hero → JS aspect-ratio), so
    // it must never reach CSS as a value. Skipping it leaves the var unset.
    if (
      standardizedValue != null &&
      standardizedValue !== "" &&
      standardizedValue !== "auto"
    ) {
      cssVars[`--mvt-${property}`] = standardizedValue;
    }
  });

  return cssVars;
};

const standardizeStyle = (
  property: string,
  value: string | number | null | undefined
) => {
  if (!value) {
    return value;
  }

  if (property.startsWith("height")) {
    return generateCssHeight(value);
  }

  return value;
};

const generateCssHeight = (height: string | number): string | number => {
  if (typeof height !== "string" || !height.includes("%")) {
    return height;
  }

  const multiplier = parseInt(height) / 100;
  return `calc(var(${APP_HEIGHT_INITIAL_CSS_VAR}) * ${multiplier})`;
};

export const isCssZeroValue = (value: string | number): boolean => {
  const normalized = String(value)
    .trim()
    .toLowerCase()
    .replace(/!important$/, "");
  return /^[-+]?0*\.?0+(?:[a-z%]+)?$/.test(normalized);
};

export const hasNonZeroStyleValue = (
  styles: any,
  key: string,
  isDesktop: boolean
) => {
  const value = isDesktop
    ? styles[getDesktopKey(key)] ?? styles[key]
    : styles[key];

  if (value == null || value === "") return false;

  const values = String(value).trim().split(/\s+/);
  if (!values.length) return false;

  return values.some((v) => !isCssZeroValue(v));
};

export const APP_HEIGHT_INITIAL_CSS_VAR = "--app-height-initial";
